import React, { useEffect } from "react";
import CheckBox from "../../../../../components/UI/CheckBox";
import { Button } from "../../../../../components/UI/Button";
import TextInput from "../../../../../components/UI/TextInput";
import Modal from "../../../../../components/UI/Modal";
import type { ProductEntity } from "../../../../../../domain/types/product";

interface BestSellerModalProps {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible: boolean;
  productsData: ProductEntity[] | null;
  setProductsData: React.Dispatch<React.SetStateAction<ProductEntity[] | null>>;
  bestSellerCount: number;
  setBestSellerCount: React.Dispatch<React.SetStateAction<number>>;
}

export const BestSellerModal = ({
  setIsModalVisible,
  isModalVisible,
  productsData,
  setProductsData,
  bestSellerCount,
  setBestSellerCount,
}: BestSellerModalProps) => {
  useEffect(() => {
    if (productsData) {
      let count = 0;
      for (let i = 0; i < productsData.length; i++) {
        if (productsData[i].isBestSeller) {
          count++;
        }
      }
      setBestSellerCount(count);
    }
  }, [productsData, setBestSellerCount]);

  const [searchKeyword, setSearchKeyword] = React.useState("");
  const MAX_BEST_SELLER_COUNT = 5;

  return (
    <>
      {isModalVisible && (
        <Modal setIsModalVisible={setIsModalVisible} title="">
          <div className="w-[calc(100vw-20vw)] max-w-[31.875rem]">
            <div className="flex flex-col items-start / mb-[1.0625rem]">
              <h2 className="mb-[0.75rem]">베스트셀러 상품 선택</h2>
              <div className="text-[0.875rem] font-[500]">
                {bestSellerCount}/{MAX_BEST_SELLER_COUNT}개 선택됨
              </div>
            </div>
            <div className="relative py-[1rem]">
              <div
                className="absolute top-0 bottom-0 left-0 right-0
              / mx-[-19px] / bg-[#F9FAFB] / outline outline-1 outline-[#E5E7EB]"
              ></div>
              <TextInput
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="w-full"
                placeholder="상품 검색..."
              />
            </div>
            <div
              className="h-[308px] overflow-y-scroll / flex flex-col
            / gap-[1.1rem] mt-[1.390625rem] mb-[1.390625rem]"
            >
              {productsData?.map((item, index) => {
                return (
                  <>
                    <div className="flex flex- justify-between items-center gap-3">
                      <div className="flex flex-row gap-[1rem] items-center">
                        <button
                          onClick={() => {
                            setProductsData((prev) => {
                              if (!prev) return prev;

                              return prev.map((product) => {
                                if (product.id !== item.id) {
                                  return product;
                                }

                                if (bestSellerCount >= MAX_BEST_SELLER_COUNT) {
                                  return {
                                    ...product,
                                    isBestSeller: false,
                                  };
                                }

                                return {
                                  ...product,
                                  isBestSeller: !product.isBestSeller,
                                };
                              });
                            });
                          }}
                        >
                          <CheckBox
                            className="min-w-[1rem]"
                            isEnabled={item.isBestSeller}
                          />
                        </button>

                        <div className="min-w-[3.75rem] h-min aspect-[1/1] / bg-[#AEAEAE] / rounded-[0.625rem]"></div>
                        <div className="flex flex-col items-start justify-center">
                          <h3 className="text-[0.9375rem]">{item.name}</h3>
                          <div className="text-[#AEAEAE] text-[12px] text-left flex flex-col">
                            <div className="mb-1">{item.description}</div>
                            <span className="text-[#4285F4]">
                              ₩{item.priceTiers?.[0]?.price ?? "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                      {item.isBestSeller ? (
                        <div
                          className="hidden min-w-[70px] justify-center md:flex text-[0.75rem] text-white / bg-[#4285F4]
                        / px-[0.8rem] py-[0.6rem] h-min / rounded-full
                        / items-center gap-[0.375rem]"
                        >
                          <div
                            className="bg-white / w-[0.375rem] h-[0.375rem]
                          / rounded-full"
                          />
                          선택됨
                        </div>
                      ) : null}
                    </div>
                    <hr />
                  </>
                );
              })}
            </div>
            <div className="relative">
              <div
                className="absolute top-0 bottom-0 left-0 right-0
              / mx-[-19px]  / bg-[#F9FAFB] outline outline-1 outline-[#E5E7EB]
              / rounded-b-[12px]"
              ></div>
              <div
                className="relative z-50 / flex flex-row justify-between items-center
              / py-[1rem] mb-[-20px]"
              >
                <div className="text-[0.8125rem] / font-normal">
                  {bestSellerCount}개 선택됨 ·{" "}
                  {productsData?.length && (
                    <>
                      {MAX_BEST_SELLER_COUNT - bestSellerCount}개 더 선택 가능
                    </>
                  )}
                </div>
                <div>
                  <Button
                    onClick={() => {
                      setIsModalVisible(false);
                    }}
                    className="w-[4.014375rem] h-[2.5625rem]"
                  >
                    완료
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
